var Backbone = require('backbone')
  , _ = require('underscore')
  , urlUtils = require('@173js/url')
  , applyQrCode = require('widgets/applyQrCode')

module.exports = Backbone.View.extend({
  events: {
    'mouseenter .btn-mobile-game-download': 'toggleQrCode'
  , 'mouseleave .btn-mobile-game-download': 'toggleQrCode'
  }
, toggleQrCode: function(e) {
    var item = $(e.currentTarget)
      , container = item.parent()

    if (!container.data('hasInitializeQrcode')) {
      applyQrCode('.qrcode-container', container, { width: 100, height: 100 })

      // Bugfix IE8 下 qrcode 样式错误
      container.find('table').css({
        margin: 0,
        'line-height': 1,
        display: 'inline-block'
      })

      container.data('hasInitializeQrcode', true)
    }

    container
      .find('.tooltip')[e.type === 'mouseenter' ? 'show' : 'hide']()
  }
})
